import * as React from "react";

import backgroundColoursCss from "../../templates/utils/backgroundColoursCss";
import styled from "../../theme/styled";
import DynamicImage from "../dynamic-image";
import {
  DynamicWrapper,
  IFieldTechnicalArticle,
  IFieldTechnicalArticleColumnType
} from "./field-technical-article";

interface IProps {
  type: IFieldTechnicalArticleColumnType;
  content: IFieldTechnicalArticle;
}

interface IParagraphBoxOutImageColumnWidthWrapper {
  className: string;
  type: IFieldTechnicalArticleColumnType;
  backgroundColors?: string[];
}

const ParagraphBoxOutImageColumnWidthWrapper = styled<
  IParagraphBoxOutImageColumnWidthWrapper,
  "div"
>("div")`
  .content-container {
    ${props => backgroundColoursCss(props.backgroundColors)};

    .content-wrapper {
      .image {
        padding-top: 8%;
        width: 100%;

        &:first-child {
          padding-top: 0;
        }
      }
    }
  }
`;

const ParagraphBoxOutImageColumnWidth = ({ type, content }: IProps) => {
  const imgRel = content.relationships;
  const image = imgRel && imgRel.field_image;
  const backgroundColors = content.field_background_colour_s_;

  if (!image) {
    return null;
  }

  return (
    <ParagraphBoxOutImageColumnWidthWrapper
      className="paragraph-box-out-image-column-width"
      type={type}
      backgroundColors={backgroundColors}
    >
      <div className="content-container">
        <DynamicWrapper type={type}>
          <div className="content-wrapper">
            <DynamicImage
              data={image}
              alt={content.field_image.alt}
            />
          </div>
        </DynamicWrapper>
      </div>
    </ParagraphBoxOutImageColumnWidthWrapper>
  );
};

export default ParagraphBoxOutImageColumnWidth;
